import styled from 'styled-components';

const HeaderPlaceHolder = styled.div`
  width: 100%;
  /* height: 46px; */
  height: 55px;
`;

export default HeaderPlaceHolder;
